import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
} from "@angular/common/http";
import {from, mergeMap, Observable} from "rxjs";
import {environment} from "@environments/environment";
import {UserService} from "@shared/services/user.service";
import {inject} from "@angular/core";
import {StorageService} from "@shared/services/storage.service";

export const InterceptorSkipHeader = "X-Skip-Interceptor";

export const AuthorizationInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const userService: UserService = inject(UserService);
  const storageService: StorageService = inject(StorageService);

  if (
    req.headers.has(InterceptorSkipHeader) ||
    /^https?:\/\//i.test(req.url)
  ) {
    const headers = req.headers.has(InterceptorSkipHeader)
      ? req.headers.delete(InterceptorSkipHeader)
      : req.headers;
    return next(req.clone({headers}));
  }

  return from(userService.getToken()).pipe(
    mergeMap((token) => {
      if (!token) {
        if (!environment.production) {
          token = storageService.getToken() || "";
        } else {
          return next(req);
        }
      }
      req = req.clone({
        setHeaders: {Authorization: `Bearer ${token}`},
      });
      return next(req);
    })
  );
};
